"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2391],{

/***/ 36527:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ useSingleFinanceLcroFarmInfo; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61706);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31501);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45813);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67496);




var useSingleFinanceLcroFarmInfo = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_0__/* .useQuery */ .a)([
        "useSingleFinanceFarmInfo"
    ], /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        var ref, fetchResponse, response, farmInfo;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        fetch("https://api.singlefinance.io/api/info/farms?chainid=25&dex=vvs")
                    ];
                case 1:
                    fetchResponse = _state.sent();
                    return [
                        4,
                        fetchResponse.json()
                    ];
                case 2:
                    response = _state.sent();
                    farmInfo = response.data.farms.find(function(v) {
                        return v.id === "CRONOS-VVS-CRO-LCRO";
                    });
                    return [
                        2,
                        {
                            tvlInUSD: farmInfo === null || farmInfo === void 0 ? void 0 : farmInfo.tvlInUSD,
                            apy: farmInfo === null || farmInfo === void 0 ? void 0 : (ref = farmInfo.bestOption) === null || ref === void 0 ? void 0 : ref.apy
                        }
                    ];
            }
        });
    }), (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, options));
};


/***/ }),

/***/ 42203:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(61706);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(45813);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(86599);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(30235);
/* harmony import */ var _ui_components_EntryPointProvider_EntryPointProvider__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20531);
/* harmony import */ var _ui_providers_VenoSDKProvider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29142);
/* harmony import */ var _ui_queries_queryKey__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51794);
/* harmony import */ var _ui_utils_bigNumberToNumber__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(19089);
/* harmony import */ var _ui_utils_tracking__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20115);
/* harmony import */ var _useAtomBalance__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18677);
/* harmony import */ var _useBalance__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44752);
/* harmony import */ var _useCoinMode__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(93397);
/* harmony import */ var _useLiquidCoinBalance__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96164);












var useStakeCoin = function(coinMode) {
    var ref = (0,_useBalance__WEBPACK_IMPORTED_MODULE_5__/* .useBalance */ .K)(), refetchCroBalance = ref.refetch, balanceCro = ref.data;
    var globalCoinMode = (0,_useCoinMode__WEBPACK_IMPORTED_MODULE_6__/* .useCoinMode */ .mc)();
    var mode = coinMode !== null && coinMode !== void 0 ? coinMode : globalCoinMode;
    var queryClient = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_8__/* .useQueryClient */ .NL)();
    var sdk = (0,_ui_providers_VenoSDKProvider__WEBPACK_IMPORTED_MODULE_1__/* .useVenoSDK */ .ho)();
    var stakeFn = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function(receiver, amount) {
            var data, _tmp, txReceipt;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(mode === "cro")) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            sdk.LiquidCro.stake(receiver, amount)
                        ];
                    case 1:
                        _tmp = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            sdk.LiquidAtom.stake(receiver, amount)
                        ];
                    case 3:
                        _tmp = _state.sent();
                        _state.label = 4;
                    case 4:
                        data = _tmp;
                        return [
                            4,
                            data.txReceiptPromise
                        ];
                    case 5:
                        txReceipt = _state.sent();
                        return [
                            2,
                            txReceipt
                        ];
                }
            });
        });
        return function stakeFn(receiver, amount) {
            return _ref.apply(this, arguments);
        };
    }();
    var entrypoint = (0,_ui_components_EntryPointProvider_EntryPointProvider__WEBPACK_IMPORTED_MODULE_0__/* .useEntryPoint */ .kc)();
    var stakeCro = function(param) {
        var receiver = param.receiver, amount = param.amount;
        return stakeFn(receiver, amount);
    };
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_11__/* .useMutation */ .D)(stakeCro, {
        onSuccess: function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function(data, vars) {
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
                    queryClient.invalidateQueries([
                        _ui_queries_queryKey__WEBPACK_IMPORTED_MODULE_2__/* .QueryKey.TOTAL_POOLED */ .S.TOTAL_POOLED
                    ]);
                    queryClient.invalidateQueries(_useLiquidCoinBalance__WEBPACK_IMPORTED_MODULE_7__/* .useLiquidCoinBalance.queryKey */ .D.queryKey(mode));
                    if (mode === "cro") {
                        refetchCroBalance();
                        queryClient.invalidateQueries([
                            _ui_queries_queryKey__WEBPACK_IMPORTED_MODULE_2__/* .QueryKey.LCRO_BALANCE */ .S.LCRO_BALANCE
                        ]);
                        queryClient.invalidateQueries([
                            _ui_queries_queryKey__WEBPACK_IMPORTED_MODULE_2__/* .QueryKey.TOTAL_SUPPLY_STCRO */ .S.TOTAL_SUPPLY_STCRO
                        ]);
                        trackStakeEvent(sdk, data, vars, balanceCro, entrypoint);
                    } else if (mode === "atom") {
                        queryClient.invalidateQueries([
                            _useAtomBalance__WEBPACK_IMPORTED_MODULE_4__/* .QUERY_KEY_ATOM_BALANCE */ .r
                        ]);
                    }
                    return [
                        2
                    ];
                });
            });
            return function(data, vars) {
                return _ref.apply(this, arguments);
            };
        }()
    });
};
function trackStakeEvent(sdk, data, vars, balance, entrypoint) {
    var receivedLcro = sdk.LiquidCro.getReceivedLcro(data);
    var receivedLcroNumber = (0,_ui_utils_bigNumberToNumber__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(receivedLcro !== null && receivedLcro !== void 0 ? receivedLcro : 0);
    var amountNumber = (0,_ui_utils_bigNumberToNumber__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(vars.amount);
    var balanceRemaining = balance ? balance - amountNumber : undefined;
    (0,_ui_utils_tracking__WEBPACK_IMPORTED_MODULE_3__/* .trackEvent */ .L9)("Stake CRO Confirmed", {
        "LCRO received": receivedLcroNumber,
        isTransaction: true,
        Amount: amountNumber,
        "Remaining Balance": balanceRemaining,
        Entrypoint: entrypoint
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (useStakeCoin);


/***/ }),

/***/ 24872:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ hooks_useStakeViewData; }
});

// EXTERNAL MODULE: ../node_modules/.pnpm/@ethersproject+units@5.7.0/node_modules/@ethersproject/units/lib.esm/index.js + 1 modules
var lib_esm = __webpack_require__(51933);
// EXTERNAL MODULE: ./src/hooks/useApr.ts
var useApr = __webpack_require__(33491);
// EXTERNAL MODULE: ./src/hooks/useCoinMode.tsx
var useCoinMode = __webpack_require__(93397);
// EXTERNAL MODULE: ./src/hooks/useCoinPerStakedCoin.ts
var useCoinPerStakedCoin = __webpack_require__(77700);
// EXTERNAL MODULE: ./src/hooks/useCoinUsdValue.ts
var useCoinUsdValue = __webpack_require__(33646);
// EXTERNAL MODULE: ./src/utils/aprToGrossApy.ts
var aprToGrossApy = __webpack_require__(29855);
// EXTERNAL MODULE: ./src/utils/apyToApyList.ts
var apyToApyList = __webpack_require__(3747);
// EXTERNAL MODULE: ../packages/wallet/dist/esm/index.js + 44 modules
var esm = __webpack_require__(95142);
// EXTERNAL MODULE: ../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(70079);
// EXTERNAL MODULE: ../node_modules/.pnpm/@tanstack+react-query@4.24.10_react-dom@18.2.0_react@18.2.0/node_modules/@tanstack/react-query/build/lib/useQuery.mjs
var useQuery = __webpack_require__(67496);
// EXTERNAL MODULE: ./src/providers/VenoSDKProvider.tsx
var VenoSDKProvider = __webpack_require__(29142);
// EXTERNAL MODULE: ./src/queries/sdk.ts
var queries_sdk = __webpack_require__(94693);
;// CONCATENATED MODULE: ./src/views/Stake/hooks/useStakeTransactionFee.ts





var useAccount = esm/* currentWallet.useAccount */.AX.useAccount;
var useStakeTransactionFee = function(_coinMode) {
    var account = useAccount();
    var sdk = (0,VenoSDKProvider/* useVenoSDK */.ho)();
    var globalCoinMode = (0,useCoinMode/* useCoinMode */.mc)();
    var coinMode = _coinMode !== null && _coinMode !== void 0 ? _coinMode : globalCoinMode;
    var stakeFeeQuery = (0,queries_sdk/* getStakeTransactionFee */.fA)(sdk, account !== null && account !== void 0 ? account : "", coinMode);
    var ref = (0,useQuery/* useQuery */.a)(stakeFeeQuery.queryKey, stakeFeeQuery.queryFn, {
        enabled: !!account
    }), stakeFee = ref.data;
    return stakeFee;
};
/* harmony default export */ var hooks_useStakeTransactionFee = (useStakeTransactionFee);

;// CONCATENATED MODULE: ./src/hooks/useStakeViewData.ts










var useIsConnected = esm/* currentWallet.useIsConnected */.AX.useIsConnected, useStakeViewData_useAccount = esm/* currentWallet.useAccount */.AX.useAccount;
var useStakeViewData = function(coinMode) {
    var isConnected = useIsConnected();
    var account = useStakeViewData_useAccount();
    var ref = (0,useCoinMode/* useCoinModeBalance */.cm)(coinMode), balance = ref.data, balanceLoading = ref.isLoading;
    var stakeFee = hooks_useStakeTransactionFee(coinMode);
    var ref1 = (0,useCoinUsdValue/* useCoinUsdValue */.x)(balance, coinMode), balanceUsd = ref1.data, balanceUsdLoading = ref1.isLoading;
    // max amount is wallet balance - transaction fee, and shown value will
    // be a bit less than that because of precision issues, rather show a value
    // that's just a bit too small so that the transaction can be sent
    var maxStakeAmount = balance && stakeFee !== undefined ? stakeFee.eq(0) ? balance : Math.max(0, Math.floor(100000000 * (balance - Math.ceil(parseFloat((0,lib_esm.formatUnits)(stakeFee, 18)) * 100000000) / 100000000)) / 100000000) : 0;
    var ref2 = (0,useCoinPerStakedCoin/* default */.Z)(coinMode), coinPerStakedCoin = ref2.data, coinPerStakedCoinLoading = ref2.isLoading;
    var ref3 = (0,useApr/* useApy */.K8)(), apy = ref3.data, apyLoading = ref3.isLoading;
    var ref4 = (0,useApr/* useApr */.LY)(), apr = ref4.data;
    var grossApy = (0,aprToGrossApy/* default */.Z)(apr);
    var apyList = (0,react.useMemo)(function() {
        return (0,apyToApyList/* default */.Z)(apy);
    }, [
        apy
    ]);
    return {
        loading: balanceLoading || coinPerStakedCoinLoading,
        balanceUsd: balanceUsd,
        balanceLoading: balanceLoading,
        balanceUsdLoading: balanceUsdLoading,
        croPerStcro: coinPerStakedCoin !== null && coinPerStakedCoin !== void 0 ? coinPerStakedCoin : undefined,
        isConnected: isConnected,
        balance: balance,
        account: account,
        apy: apy,
        apyList: apyList,
        stakeFee: stakeFee,
        maxStakeAmount: maxStakeAmount,
        apyLoading: apyLoading,
        grossApy: grossApy
    };
};
/* harmony default export */ var hooks_useStakeViewData = (useStakeViewData);


/***/ }),

/***/ 11571:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H": function() { return /* binding */ useUseLcroPartnerCardsData; }
});

// EXTERNAL MODULE: ../node_modules/.pnpm/@ethersproject+units@5.7.0/node_modules/@ethersproject/units/lib.esm/index.js + 1 modules
var lib_esm = __webpack_require__(51933);
;// CONCATENATED MODULE: ./public/images/ferro-logo.png
/* harmony default export */ var ferro_logo = ({"src":"/_next/static/media/ferro-logo.752c002f.png","height":35,"width":152,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAQAAADPnVVmAAAAK0lEQVR42mOYmjU1clrklPyJSVOq+oKmRDHUOLZYNidWBVb710RW+lVHAQD7hw4TVTjt0wAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./public/images/single-text-logo.png
/* harmony default export */ var single_text_logo = ({"src":"/_next/static/media/single-text-logo.525a0876.png","height":61,"width":114,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAAdklEQVR42g3JsQ3CMBCG0SRyg4ASxAasAMPQswWUjMEqGYAlaCKEoAJLPt/3X1y94vXXi93kPKiCylceWc5eRHHjk6i8VTmK+LU0wU6uhCsHWieKPyFGzCd5/FueQjGVbOMw9IsEscVYtjy03OC8mqu+684i7jMA42pxROAelQAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":4});
;// CONCATENATED MODULE: ./public/images/tectonic-logo.png
/* harmony default export */ var tectonic_logo = ({"src":"/_next/static/media/tectonic-logo.ad977616.png","height":34,"width":240,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAAH0lEQVR4nGNkYGDIAGJbIH4HxAeB2AKIpYH4DxB/AgA7/wSX1XjN3wAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":1});
// EXTERNAL MODULE: ./public/images/use-ferro.png
var use_ferro = __webpack_require__(30842);
;// CONCATENATED MODULE: ./public/images/use-single.png
/* harmony default export */ var use_single = ({"src":"/_next/static/media/use-single.d3373101.png","height":88,"width":88,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAABBElEQVR42h2Ku0oDQRiF5xkEL69i4xNoIdjYWQQvCMIqYhVF1I2FWAjBtYmFCJFgERSRZBVtousGGy0UBLUQNbvJXnXYZOY/2UnxweF8HwPAUvokkf7bhPntwhSCdPUpx9wWhm7vpLVfAE4OP+TZ0bPMGwnMKrecRmeQPT6RsbbZhlaE/LJ3EJZHkMnFcnE2gHXPDfb2LmvZbIJcuU17lgP9/BMLuz4tZTy8viQ1FsVU0be4WDmIMH8ZYOKmganCD1ZnPBFGosIArF9fJf6kFmA535LativHhh1UL2JfORUMEFHptPjH58Y9TI82UToOufqUU0EvStmo29yuP/zbaqf0A2Bd1AHJL/D9q5AAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
// EXTERNAL MODULE: ./public/images/use-tectonic.png
var use_tectonic = __webpack_require__(34061);
// EXTERNAL MODULE: ./public/images/use-vvs.png
var use_vvs = __webpack_require__(33267);
;// CONCATENATED MODULE: ./public/images/vvs-logo.png
/* harmony default export */ var vvs_logo = ({"src":"/_next/static/media/vvs-logo.aaccfb3f.png","height":35,"width":236,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAAIElEQVR4nGMUE5ecycDAsAiI+YD4PxD/AWJeIP4NxP8BTxwFky/xGaUAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":1});
// EXTERNAL MODULE: ../node_modules/.pnpm/@tanstack+react-query@4.24.10_react-dom@18.2.0_react@18.2.0/node_modules/@tanstack/react-query/build/lib/useQuery.mjs
var useQuery = __webpack_require__(67496);
// EXTERNAL MODULE: ./src/components/Features.tsx
var Features = __webpack_require__(18232);
// EXTERNAL MODULE: ./src/hooks/useCoinMode.tsx
var useCoinMode = __webpack_require__(93397);
// EXTERNAL MODULE: ./src/hooks/useGardenApy.ts
var useGardenApy = __webpack_require__(55814);
// EXTERNAL MODULE: ./src/hooks/usePartnerStats.ts
var usePartnerStats = __webpack_require__(82251);
// EXTERNAL MODULE: ./src/i18n/index.ts
var i18n = __webpack_require__(68866);
// EXTERNAL MODULE: ./src/queries/queries.ts + 4 modules
var queries = __webpack_require__(54495);
// EXTERNAL MODULE: ./src/queries/queryKey.ts
var queryKey = __webpack_require__(51794);
// EXTERNAL MODULE: ./src/utils/format.ts
var format = __webpack_require__(25966);
// EXTERNAL MODULE: ./src/utils/garden.ts
var garden = __webpack_require__(98097);
// EXTERNAL MODULE: ./src/hooks/useIsFeatureEnabled.ts
var useIsFeatureEnabled = __webpack_require__(79623);
// EXTERNAL MODULE: ./src/hooks/useSingleFinanceLcroFarmInfo.ts
var useSingleFinanceLcroFarmInfo = __webpack_require__(36527);
;// CONCATENATED MODULE: ./src/hooks/useUseLcroPartnerCardsData.ts





















var atomTectonicEnabled = (0,useIsFeatureEnabled/* isFeatureEnabled */.cr)(Features/* features.AtomTectonic */.R.AtomTectonic);
var AtomTectonicGardenEnabled = (0,useIsFeatureEnabled/* isFeatureEnabled */.cr)(Features/* features.AtomTectonicGarden */.R.AtomTectonicGarden);
var atomVvsGardenEnabled = (0,useIsFeatureEnabled/* isFeatureEnabled */.cr)(Features/* features.atomVvsGarden */.R.atomVvsGarden);
var useUseLcroPartnerCardsData = function(coinMode) {
    var ref, ref1;
    var t = (0,i18n/* useTranslations */.T_)();
    var globalCoinMode = (0,useCoinMode/* useGlobalCoinMode */.KN)();
    var mode = coinMode !== null && coinMode !== void 0 ? coinMode : globalCoinMode;
    var coinModeInfo = useCoinMode/* COIN_MODE */.rm[mode];
    var singleFinanceFarmTvlRet = (0,useSingleFinanceLcroFarmInfo/* useSingleFinanceLcroFarmInfo */.Q)();
    var ref2 = (0,useGardenApy/* default */.Z)(undefined, true), ferroGardenApy = ref2.ferroGardenApy, tectonicGardenApy = ref2.tectonicGardenApy, vvsCroGardenApy = ref2.vvsCroGardenApy;
    var tectonicApyRet = (0,usePartnerStats/* useTectonicApy */.Gh)();
    var ferroTvlQuery = (0,queries/* getQuery */.p)(queryKey/* QueryKey.GET_FERRO_TOTAL_LOCKED_VALUE */.S.GET_FERRO_TOTAL_LOCKED_VALUE)({
        coinMode: mode
    });
    var ref3 = (0,useQuery/* useQuery */.a)(ferroTvlQuery.queryKey, ferroTvlQuery.queryFn), ferroTvl = ref3.data, ferroTvlError = ref3.error;
    var ref4 = (0,usePartnerStats/* useTectonicSupplyUsd */.j3)(), tectonicSupplyUsd = ref4.data, tectonicTvlError = ref4.error;
    var tectonicSupply = tectonicSupplyUsd ? parseFloat((0,lib_esm.formatUnits)(tectonicSupplyUsd !== null && tectonicSupplyUsd !== void 0 ? tectonicSupplyUsd : 0, 18)) : undefined;
    var ferroData = {
        logoWidth: "88px",
        image: use_ferro/* default */.Z,
        logo: ferro_logo,
        description: t("Provide liquidity for {liquidCoin} on Cronos' leading stable swap and earn additional rewards on your {liquidCoin} Earn even more with the {garden}", {
            liquidCoin: coinModeInfo.liquidName,
            garden: (0,garden/* getGardenName */.gr)(mode, "FERRO")
        }),
        buttonText: t("Supply {coin} on {platform}", {
            coin: coinModeInfo.liquidName,
            platform: "Ferro"
        }),
        tvl: ferroTvlError ? null : ferroTvl ? (0,format/* formatNumber */.uf)(ferroTvl, 2, true, true) : "",
        apy: ferroGardenApy === 0 ? null : (0,garden/* formatGardenApy */.VV)(ferroGardenApy),
        type: "FERRO"
    };
    var tectonicData = {
        comingSoon: coinMode === "atom" && !atomTectonicEnabled,
        logoWidth: "140px",
        image: use_tectonic/* default */.Z,
        logo: tectonic_logo,
        description: coinMode === "atom" && !AtomTectonicGardenEnabled ? t("use-latom-tectonic-desc") : t("Supply {liquidCoin} on the leading money market on Cronos and earn interest from borrowers Earn additional rewards with the {garden}", {
            liquidCoin: coinModeInfo.liquidName,
            garden: (0,garden/* getGardenName */.gr)(mode, "TECTONIC")
        }),
        buttonText: t("Supply {coin} on {platform}", {
            coin: coinModeInfo.liquidName,
            platform: "Tectonic"
        }),
        tvl: tectonicTvlError ? null : tectonicSupply !== undefined ? (0,format/* formatNumber */.uf)(tectonicSupply, 2, true, true) : "",
        apy: function() {
            if (coinMode === "atom" && !AtomTectonicGardenEnabled) {
                if (tectonicApyRet.error || tectonicApyRet.data === 0) {
                    return null;
                }
                return typeof tectonicApyRet.data !== "undefined" ? (0,garden/* formatGardenApy */.VV)(tectonicApyRet.data / 100) : undefined;
            }
            return tectonicGardenApy === 0 ? null : (0,garden/* formatGardenApy */.VV)(tectonicGardenApy);
        }(),
        type: "TECTONIC"
    };
    var vvsData = {
        comingSoon: coinMode === "atom" && !atomVvsGardenEnabled,
        logoWidth: "140px",
        image: use_vvs/* default */.Z,
        logo: vvs_logo,
        description: t("Put your {liquidCoin} to work on VVS Finance to earn attractive yield farming rewards!", {
            liquidCoin: coinModeInfo.liquidName
        }),
        buttonText: t("Supply {coin} on {platform}", {
            coin: coinModeInfo.liquidName,
            platform: "VVS"
        }),
        tvl: null,
        apy: vvsCroGardenApy === 0 ? null : (0,garden/* formatGardenApy */.VV)(vvsCroGardenApy),
        type: "VVS_CRO"
    };
    var singleFinanceData = {
        logoWidth: "57px",
        logoHeight: "30px",
        image: use_single,
        logo: single_text_logo,
        description: t("Use {liquidCoin} for leveraged yield farming on Single Finance", {
            liquidCoin: coinModeInfo.liquidName
        }),
        buttonText: t("Supply {coin} on {platform}", {
            coin: coinModeInfo.liquidName,
            platform: "Single"
        }),
        tvl: ((ref = singleFinanceFarmTvlRet.data) === null || ref === void 0 ? void 0 : ref.tvlInUSD) ? "$".concat((0,format/* formatNumber */.uf)(singleFinanceFarmTvlRet.data.tvlInUSD, 2)) : null,
        apy: ((ref1 = singleFinanceFarmTvlRet.data) === null || ref1 === void 0 ? void 0 : ref1.apy) ? (0,format/* formatPercentage */.rl)(singleFinanceFarmTvlRet.data.apy) : null,
        type: "SINGLE"
    };
    var partnerCardData = coinMode === "atom" ? [
        ferroData,
        tectonicData,
        vvsData
    ] : [
        tectonicData,
        ferroData,
        singleFinanceData
    ];
    return {
        ferroApy: ferroGardenApy,
        ferroTvl: ferroTvl,
        ferroTvlError: ferroTvlError,
        tectonicSupply: tectonicSupply,
        tectonicApy: tectonicGardenApy,
        vvsCroApy: vvsCroGardenApy,
        partnerCardData: partnerCardData
    };
};


/***/ }),

/***/ 29855:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

//docs.google.com/spreadsheets/d/1sagvdvWwY8frTCMy9whR1fF-E359DvviHG0KDHlKoZA
var PER_WEEK = 504;
var PER_YEAR = 26280;
var MANAGEMENT_FEE = 0.1;
var aprToGrossApy = function(sevenDayApr) {
    if (sevenDayApr === undefined) return sevenDayApr;
    var netPerPeriod = Math.pow(1 + sevenDayApr * 7 / 365, 1 / PER_WEEK) - 1;
    var grossPerPeriod = netPerPeriod / (1 - MANAGEMENT_FEE);
    var feePercentPerPeriod = grossPerPeriod * MANAGEMENT_FEE;
    var netApy = Math.pow(1 + netPerPeriod, PER_YEAR) - 1;
    var feeApyPerYear = (1 - Math.pow(1 + feePercentPerPeriod, PER_YEAR)) / -feePercentPerPeriod * feePercentPerPeriod;
    var grossApy = netApy + feeApyPerYear;
    return grossApy;
};
/* harmony default export */ __webpack_exports__["Z"] = (aprToGrossApy);


/***/ }),

/***/ 3747:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var apyToApyList = function(apy) {
    var monthApy = Math.pow(1 + apy, 1 / 12) - 1;
    return [
        monthApy,
        Math.pow(1 + monthApy, 6) - 1,
        apy,
        Math.pow(1 + monthApy, 24) - 1, 
    ];
};
/* harmony default export */ __webpack_exports__["Z"] = (apyToApyList);


/***/ }),

/***/ 12127:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ doApprovals; },
/* harmony export */   "U": function() { return /* binding */ getReceivedCoin; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61706);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45813);
/* harmony import */ var _ethersproject_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5577);



var getReceivedCoin = function(receipt, coinMode, sdk) {
    if (coinMode === "cro") return sdk.LiquidCro.getReceivedLcro(receipt);
    return sdk.LiquidAtom.getReceivedLatom(receipt);
};
var doApprovals = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(sdk, account, amount, setNSteps, setCurrentStep, coinMode) {
        var allowance, approveRet;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    setNSteps(1);
                    setCurrentStep(1);
                    if (coinMode === "cro") return [
                        2
                    ];
                    return [
                        4,
                        sdk.Atom.allowance(account !== null && account !== void 0 ? account : "", sdk.LiquidAtom.contractAddress)
                    ];
                case 1:
                    allowance = _state.sent();
                    if (!allowance.lt(amount)) return [
                        3,
                        4
                    ];
                    setNSteps(2);
                    setCurrentStep(1);
                    return [
                        4,
                        sdk.Atom.approve(sdk.LiquidAtom.contractAddress, _ethersproject_constants__WEBPACK_IMPORTED_MODULE_2__/* .MaxUint256 */ .Bz)
                    ];
                case 2:
                    approveRet = _state.sent();
                    return [
                        4,
                        approveRet.txReceiptPromise
                    ];
                case 3:
                    _state.sent();
                    setCurrentStep(2);
                    _state.label = 4;
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function doApprovals(sdk, account, amount, setNSteps, setCurrentStep, coinMode) {
        return _ref.apply(this, arguments);
    };
}();


/***/ })

}]);